<img src="../../../assets/img/404.jpg" alt="" class="d-block img-fluid mx-auto">
<a [routerLink]="['']" class="d-block text-center text-white text-sm"> {{ 'SHARED.TO_HOME' | translate }} </a> 